const TOKEN_COOKIE_NAME = "teba_auth_token";
const TOKEN_STORAGE_KEY = "token";
const FAMILY_MEMBERS_KEY = "teba_family_members";
const SELECTED_MEMBER_KEY = "teba_selected_member_id";

export const getAuthToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${TOKEN_COOKIE_NAME}=`))
    ?.split("=")[1] || null;

export const setAuthToken = (token) => {
  if (!token) {
    return;
  }

  const isSecure = window.location.protocol === "https:";
  document.cookie = `${TOKEN_COOKIE_NAME}=${token}; path=/; SameSite=Strict${
    isSecure ? "; Secure" : ""
  }; max-age=${3 * 60 * 60}`;
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
  sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
};

export const clearAuthStorage = () => {
  document.cookie = `${TOKEN_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(FAMILY_MEMBERS_KEY);
  sessionStorage.removeItem(FAMILY_MEMBERS_KEY);
  localStorage.removeItem(SELECTED_MEMBER_KEY);
  sessionStorage.removeItem(SELECTED_MEMBER_KEY);
};

export const persistSessionMetadata = (sessionData = {}) => {
  const familyMembers = sessionData.family_members || sessionData.familyMembers || [];
  const selectedMemberId =
    sessionData.selected_member_id || sessionData.selectedMemberId || null;

  if (Array.isArray(familyMembers) && familyMembers.length > 0) {
    const serialized = JSON.stringify(familyMembers);
    localStorage.setItem(FAMILY_MEMBERS_KEY, serialized);
    sessionStorage.setItem(FAMILY_MEMBERS_KEY, serialized);
  } else {
    localStorage.removeItem(FAMILY_MEMBERS_KEY);
    sessionStorage.removeItem(FAMILY_MEMBERS_KEY);
  }

  if (selectedMemberId) {
    localStorage.setItem(SELECTED_MEMBER_KEY, String(selectedMemberId));
    sessionStorage.setItem(SELECTED_MEMBER_KEY, String(selectedMemberId));
  } else {
    localStorage.removeItem(SELECTED_MEMBER_KEY);
    sessionStorage.removeItem(SELECTED_MEMBER_KEY);
  }
};

export const getStoredFamilyMembers = () => {
  const raw = localStorage.getItem(FAMILY_MEMBERS_KEY) || sessionStorage.getItem(FAMILY_MEMBERS_KEY);
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export const getStoredSelectedMemberId = () =>
  localStorage.getItem(SELECTED_MEMBER_KEY) || sessionStorage.getItem(SELECTED_MEMBER_KEY) || null;

export const setStoredSelectedMemberId = (memberId) => {
  if (!memberId) {
    localStorage.removeItem(SELECTED_MEMBER_KEY);
    sessionStorage.removeItem(SELECTED_MEMBER_KEY);
    return;
  }

  localStorage.setItem(SELECTED_MEMBER_KEY, String(memberId));
  sessionStorage.setItem(SELECTED_MEMBER_KEY, String(memberId));
};